<template>
    <div class="bank-selections">
        <BankSelectionDetailsModal :show_bank_details.sync="modals.show_bank_details" :bank="view_bank" />
        <CompareBanksModal :compare_banks.sync="modals.compare_banks" :banks="multipleSelection" />
        <p class="text-right text-muted text-xs mb-2">
            Banks marked with 
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512"><path fill="#F3BC43" d="M316.9 18c-5.3-11-16.5-18-28.8-18s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329l-24.6 145.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329l104.2-103.1c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7l-143.7-21.2L316.9 18z"/></svg>
            are recommendation
        </p>
        <div class="card-table">
            <el-alert
                v-if="multipleSelection.length > 0"
                class="compare-banks"
                effect="dark"
                @close="emptySelection"
                >
                <b-row>
                    <b-col cols="4" md="auto" class="bg-white rounded mx-2 p-2 mb-2 mb-md-0" align-self="center" v-for="(bank, index) in multipleSelection" :key="index">
                        <el-image class="bank-logo--compare" :src="bank.bank_image_url" fit="contain">
                            <template #error>
                                <div class="image-slot">
                                    <span class="text-dark text-xs text-truncate px-md-4 px-2 pt-1">{{ bank.bank_name }}</span>
                                </div>
                            </template>
                        </el-image>
                    </b-col>
                    <b-col cols="6" md="auto" class="border-left text-center" align-self="center">
                        <b-button variant="primary" class="mb-1" @click="compareBanks">Compare</b-button>
                        <div>{{ multipleSelection.length }} banks selected (Max. 5)</div>
                    </b-col>
                </b-row>
            </el-alert>
            <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            >
                <el-table-column width="30">
                    <template slot-scope="scope">
                        <svg v-if="isPreferredBank(scope.row.bank_name)" xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
                            <path fill="#F3BC43" d="M316.9 18c-5.3-11-16.5-18-28.8-18s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329l-24.6 145.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329l104.2-103.1c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7l-143.7-21.2L316.9 18z"/>
                        </svg>
                    </template>
                </el-table-column>

                <el-table-column
                v-if="checkIsCorporatePackageSubscription()"
                type="selection"
                width="55"
                :selectable="(row) => row.bank_code!== 'CASH_BUYER'"
                >
                </el-table-column>
                <el-table-column
                    prop="bank_name"
                    label="Bank Name"
                    min-width="140"
                    >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <div class="bank-logo-cell">
                            <el-image class="bank-logo" :src="scope.row.bank_image_url" fit="contain">
                            <template #error>
                                <div class="image-slot">
                                  <span class="d-inline-block text-truncate" :style="{ maxWidth: scope.row.bank_name === 'Cash Buyer' ? '150px' : '90px' }">{{ scope.row.bank_name }}</span>
                                </div>
                            </template>
                            </el-image>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="est_interest_rate"
                    label="Est Interest Rate"
                    min-width="120"
                    >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                      <template v-if="scope.row.bank_code !== 'CASH_BUYER'">
                        <p class="top-line">{{ scope.row.bank_loan_interest_rate }}% p.a</p>
                      </template>

                    </template>
                </el-table-column>
                <el-table-column
                    prop="max_eligibility"
                    label="Max Eligibility Amount"
                    min-width="190"
                    >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                      <template v-if="scope.row.bank_code !== 'CASH_BUYER'">
                        <span class="top-line mr-2" :class="scope.row.bank_loan_eligibility_amount > 0 ? 'text-success':'text-danger'">RM {{ scope.row.bank_loan_eligibility_amount | moneyFormatter }}</span>
                        <span>({{ scope.row.bank_loan_tenure_year }} yrs)</span>
                      </template>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="monthly_repayment"
                    label="Monthly Repayment"
                    min-width="130"
                    >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                      <template v-if="scope.row.bank_code !== 'CASH_BUYER'">
                        <p class="top-line">RM {{ scope.row.bank_installable_amount | moneyFormatter }}</p>
                      </template>
                    </template>

                </el-table-column>
                <el-table-column
                    v-if="checkIsCorporateSubscription()"
                    label="Bank Details"
                    min-width="90"
                    >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                      <template v-if="scope.row.bank_code !== 'CASH_BUYER'">
                        <el-button type="text" @click="showBankDetails(scope.row)">View</el-button>
                      </template>  
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="120"
                    >
                    <template slot-scope="scope">
                        <b-button class="m-2" variant="primary" v-if="scope.row.bank_code !== 'CASH_BUYER'" @click="emitEvent('show-summary-selections', scope.row)">Apply Bank</b-button>
                        <b-button class="m-2" variant="success" v-else @click="emitEvent('show-summary-selections', scope.row)">Proceed</b-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import { Table, TableColumn, Button, Image, Alert } from 'element-ui'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'
import BankSelectionDetailsModal from '@/views/CustomerProfile/CustomerModals/SolutionScenarioModals/BankSelectionDetailsModal'
import CompareBanksModal from '@/views/CustomerProfile/CustomerModals/SolutionScenarioModals/CompareBanksModal'
import { mapActions, mapState } from 'pinia'
import { useProductStore } from '@/stores/productStore'
import { usePMPStore } from '@/stores/pmpStore'
import { useCustomerStore } from '@/stores/customerStore'
import { useLookupStore } from '@/stores/lookupStore'

import {
    helperFunctionMixin,
    notifyFunctionMixin,
} from '@/assets/js/httpImports.js'
import { useAuthStore } from '@/stores/authStore'

export default {
    components: {
        BankSelectionDetailsModal,
        CompareBanksModal,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Button.name]: Button,
        [Image.name]: Image,
        [Alert.name]: Alert,
    },
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    data() {
        return {
            tableData: [],
            modals: {
                show_bank_details: false,
                compare_banks: false
            },
            view_bank: null,
            multipleSelection: []
        }
    },
    computed:{
        ...mapState(useCustomerStore, ['current_eligibility']),
        ...mapState(useAuthStore, ['auth_user']),
        ...mapState(useProductStore, ['current_product_data']),
    },
    async created(){
        await this.getPMPProjectsBasic()
        this.setBank()
        this.getBanks()
    },
    watch:{
        '$route.query.project_id':{
            handler(newVal){
                this.setBank()
            }
        },
        current_eligibility(newVal, oldVal){
            if(!_.isEqual(newVal, oldVal)){
                this.setBank()
            }
        },
        current_product_data: {
            handler(newVal) {
                if (newVal && newVal.project) {
                    this.rearrangeBanksArray()
                }
            },
            deep: true
        }
    },
    methods: {
        ...mapActions(useCustomerStore, ['getEligibility']),
        ...mapActions(useProductStore, ['addPropertyProductBank', 'createPropertyProduct']),
        ...mapActions(usePMPStore, ['getPMPBankCodesByProject', 'getPMPProjectsBasic']),
        ...mapActions(useLookupStore, ['getBanks']),
        async emitEvent(eventName, bank) {
            // set bank_code to query params
            // this.$router.replace({query: { ...this.$route.query, bank_code: bank.bank_code },},() => {})
            // if has product id add bank to product
            if(this.$route.query.product_id){
                try{
                    await this.addPropertyProductBank(this.$route.query.product_id, bank)
                    this.notifySuccess('<b>Bank</b> - Successfully Added.')
                    solutionEventBus.$emit('show-summary-selections')
                    // remove product id once added bank
                    const currentQuery = { ...this.$route.query };
                    delete currentQuery.product_id;
                    delete currentQuery.bank_code;
                    delete currentQuery.project_id;
                    this.$router.replace({query: currentQuery,},() => {})
                }catch(e){
                    this.errorFunction(null, e)
                }
            }else{
                useProductStore().$patch((state) => {
                    state.current_product_data = { ...state.current_product_data, banks: [bank] }
                })

                try{
                    await this.createPropertyProduct()
                    this.notifySuccess('<b>Draft </b> - Successfully Created.')
                    solutionEventBus.$emit('show-summary-selections')
                }catch(e){
                    this.errorFunction(null, e)
                }
                solutionEventBus.$emit(eventName)
            }
        },
        showBankDetails(bank) {
            this.modals.show_bank_details = true
            this.view_bank = bank
        },
        handleSelectionChange(val) {
            if(val.length <= 5){
                this.multipleSelection = val
            }
        },
        emptySelection() {
            this.$refs.multipleTable.clearSelection()
        },
        compareBanks() {
            this.modals.compare_banks = true
        },
        setBank(){
            let current_bank_code = this.getPMPBankCodesByProject(this.$route.query.project_id ?? null)
            const limit = this.auth_user.subscription.privileges.scpk_limit_bank
            const preferredBanks = this.auth_user.subscription.scrb_banks

            if(current_bank_code.length > 0){
                this.tableData = JSON.parse(JSON.stringify(this.current_eligibility.bank_eligibilities.filter((bank) => current_bank_code.includes(bank.bank_code))))
            }else{
                this.tableData = JSON.parse(JSON.stringify(this.current_eligibility.bank_eligibilities))
            }

            if(preferredBanks.length > 0){
                this.tableData.forEach((bank, index) => {
                    if(preferredBanks.find((item) => item.bank_code === bank.bank_code)){
                        this.tableData.unshift(this.tableData.splice(index, 1)[0]);
                    }
                })
                this.tableData.length = preferredBanks.length
            }else{
                if(limit){
                    this.tableData.length = limit
                }
            }
            this.tableData.sort((a, b) => parseFloat(a.bank_loan_eligibility_amount) > parseFloat(b.bank_loan_eligibility_amount) ? -1 : 1);
          // Define the Cash Buyer object
              const cashBuyer = {
                  bank_id: '37',
                  bank_code: 'CASH_BUYER',
                  bank_name: 'Cash Buyer',
                  bank_image_url: '', // URL to a placeholder image if necessary
                  bank_loan_interest_rate: '0.00',
                  bank_loan_eligibility_amount: '0',
                  bank_installable_amount: '0.00',
                  bank_loan_tenure_year: '0',
                  is_recommended: false,
                  is_cash_buyer: true  // New property to identify the Cash Buyer
              };

              // Add the Cash Buyer to the beginning of the tableData array
              this.tableData.unshift(cashBuyer);

              // Sort the tableData by bank_loan_eligibility_amount descending, keeping Cash Buyer first
              this.tableData.sort((a, b) => {
                  if (a.is_cash_buyer) return -1;
                  if (b.is_cash_buyer) return 1;
                  return parseFloat(b.bank_loan_eligibility_amount) - parseFloat(a.bank_loan_eligibility_amount);
              });
        },
        rearrangeBanksArray() {
            // Find the objects to be moved to the top
            const banksToMove = this.current_product_data.project.project_banks.map(obj => obj.bank_name || obj.bank_detail.name)

            // Create a map of bank names to their indices in tableData
            const indexMap = new Map();
            this.tableData.forEach((item, index) => {
                indexMap.set(item.bank_name, index)
            });

            // Rearrange the tableData array based on banksToMove
            const rearrangedTableData = [];
            banksToMove.forEach(bankName => {
                const index = indexMap.get(bankName);
                if (index !== undefined) {
                    rearrangedTableData.push(this.tableData[index]);
                }
            });
            this.tableData.forEach(item => {
                if (!banksToMove.includes(item.bank_name)) {
                    rearrangedTableData.push(item);
                }
            });

            // Update tableData with the rearranged array
            this.tableData = rearrangedTableData;
        },
        isPreferredBank(bankName) {
            if (this.current_product_data && this.current_product_data.project) {
                return this.current_product_data.project.project_banks.some(
                    element => element.bank_name === bankName || (element.bank_detail && element.bank_detail.name === bankName)
                )
            }
            return false
        }
    }
}
</script>
